import React from 'react';
import { Tabs, TabsPane } from '../../Tabs';
import { FundDocuments } from '../../Modules/FundDocuments';
import { ProductFieldsTable } from '../ProductFieldsTable';
var comissionsFields = [{
  id: 'fee',
  fee: 'MGR'
}, {
  id: 'fee',
  fee: 'SUC'
}, {
  id: 'fee',
  fee: 'CUS'
}, {
  id: 'fee',
  fee: 'OGC'
}, {
  id: 'fee',
  fee: 'RED'
}, {
  id: 'fee',
  fee: 'FLO'
}];
var summaryFields = [{
  id: 'managementCompany',
  variant: 'link'
}, {
  id: 'category',
  variant: 'link'
}, 'benchmarks', 'indexed', 'totalNetAsset', 'classTotalNetAsset', 'inceptionDate'];
export var FundInfoTabs = function FundInfoTabs(props) {
  var fund = props.fund;
  var product = {
    entity: fund,
    subtype: fund.subtype
  };
  return React.createElement(Tabs, null, React.createElement(TabsPane, {
    title: "Resumen"
  }, React.createElement(ProductFieldsTable, {
    product: product,
    fields: summaryFields
  })), React.createElement(TabsPane, {
    title: "Comisiones"
  }, React.createElement(ProductFieldsTable, {
    product: product,
    fields: comissionsFields
  })), React.createElement(TabsPane, {
    title: "Documentos"
  }, React.createElement(FundDocuments, {
    fund: fund
  })));
};